export const SERVER_ALERT = {
  NORMAL: 0,
  PRESSURE_AVAILABLE: 1,
  PRESSURE_UNAVAILABLE: 2,
  UNAVAILABLE: 3,
  OFFLINE: 4,
} as const;

export type ServerAlertEnum = (typeof SERVER_ALERT)[keyof typeof SERVER_ALERT];

export interface StatusInfo {
  code: number;
  message: string;
  serverAlert: ServerAlertEnum;
  serviceTime: number;
  requestID: string;
  debugInfo: string;
}

export interface ApiResp<Data> {
  data: Data;
  statusInfo: StatusInfo;
}

export interface PagingData<T> {
  page: number;
  pageSize: number;
  total: number;
  items: T[];
}

export interface Pagination {
  page: number;
  pageSize: number;
}

export type ApiError = Pick<StatusInfo, 'message' | 'code'>;

export function isApiError(err: unknown): err is ApiError {
  return (err as StatusInfo).serviceTime !== undefined && (err as StatusInfo).message !== undefined;
}

export { isAxiosError } from 'axios';

export interface Issue {
  title: string;
  list: string[];
}

export interface NegativeReview {
  voice_call: Issue[];
  text_chat: Issue[];
}
